module.exports = __webpack_public_path__ + "img/a-pikto.eca96e69.svg";